import { RowMiddle } from 'layout/Components/Row'
import React from 'react'
import styled from 'styled-components'
import AlchemyModal, { ModalBody, ModalHeader, ModalProps } from 'UIKit/AlchemyModal'
import Box from 'UIKit/Box/Box'
import { GameFilterOptionType } from '../config'
import GameFilterOptionItem from './GameFilterOptionItem'

export interface GameFilterModalProps {
  selectedOption: GameFilterOptionType
  onSelectOption: (option: GameFilterOptionType) => void
  filterOptions?: GameFilterOptionType[]
  onDismiss?: () => void
}

const GameFilterModal: React.FC<ModalProps<GameFilterModalProps>> = ({ onDismiss, data }) => {
  const handleSelectOption = (option: GameFilterOptionType) => {
    data?.onSelectOption(option)
    onDismiss?.()
  }

  return (
    <AlchemyModal onDismiss={onDismiss} colorTheme="darkblue">
      <ModalHeader colorTheme="darkblue" title="Sort by" />

      <ModalBody>
        <Box>
          {(data?.filterOptions || []).map((option) => (
            <StyledBox
              key={option.key}
              isSelected={option.key === data?.selectedOption?.key}
              mb="4px"
              onClick={() => handleSelectOption(option)}
              p="12px"
            >
              <RowMiddle>
                <GameFilterOptionItem item={option} />
              </RowMiddle>
            </StyledBox>
          ))}
        </Box>
      </ModalBody>
    </AlchemyModal>
  )
}

const StyledBox = styled(Box)<{ isSelected: boolean }>`
  background: ${({ isSelected, theme }) => (isSelected ? theme.colors.card_primary_active_alt : 'transparent')};
  border: 1px solid ${({ isSelected, theme }) => (isSelected ? theme.colors.primary : 'transparent')};
  border-radius: ${({ theme }) => theme.radii.button};

  &:hover {
    background: ${({ theme }) => theme.colors.card_primary_active_alt};
  }
`

export default GameFilterModal
